import { j as r } from "./atoms-v218.js";
import { useContext as s } from "react";
import { Icon as t } from "./atoms-v217.js";
import { GridHelperContext as n } from "./atoms-v2124.js";
import { Toggle as l, Helper as m } from "./atoms-v2814.js";
const f = () => {
  const { isGridVisible: e, setIsGridVisible: o } = s(n);
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      l,
      {
        iconOnly: !0,
        onClick: () => o(!e),
        size: "small",
        variant: "secondary",
        children: /* @__PURE__ */ r.jsx(t, { name: e ? "view-off" : "view" })
      }
    ),
    e ? /* @__PURE__ */ r.jsx(m, { "data-testid": "grid-helper", children: [...Array(16).keys()].map((i) => /* @__PURE__ */ r.jsx("div", { children: i + 1 }, i)) }) : null
  ] });
};
export {
  f as GridHelper
};
